/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "streaming": {
            "nested": {
              "offlinepayments": {
                "nested": {
                  "OfflinePaymentsEnablementType": {
                    "values": {
                      "OFFLINE_PAYMENTS_ENABLEMENT_TYPE_DO_NOT_USE": 0,
                      "OFFLINE_PAYMENTS_ENABLEMENT_TYPE_MANUAL_OPT_IN": 1,
                      "OFFLINE_PAYMENTS_ENABLEMENT_TYPE_OPT_OUT": 2,
                      "OFFLINE_PAYMENTS_ENABLEMENT_TYPE_AUTO_OPT_IN": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.streaming?.nested?.offlinepayments?.nested?.OfflinePaymentsEnablementType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE OfflinePaymentsEnablementType @ squareup/devicesettings/streaming/offlinepayments/offline_payments_merchant_default.proto at 10:1
 */
export const OfflinePaymentsEnablementType = $root.lookupEnum('squareup.devicesettings.streaming.offlinepayments.OfflinePaymentsEnablementType').values;